module.exports = __webpack_public_path__ + "static/logo-white-13c7450b7c0cddb2ff6e1339159dfc74.png";